import { memo } from 'react'

import { DndContext, pointerWithin, type DragEndEvent } from '@dnd-kit/core'

import { GRID_DOM_BODY } from '../grid/grid.const'
import { NextHardStartCueOverlay } from '../transport/NextHardStartCueOverlay'

import { dropCue } from './cue-dnd.actions'
import { cueDndActions } from './cue-dnd.store'
import { useVisibleIndexedCues } from './cue.hooks'
import { CueDraggable } from './CueDraggable'
import { CueDragOverlay } from './CueDragOverlay'

/**
 * The rundown's cues, in order, as draggable rows.
 */
export const CueList = memo(function CueList() {
  const visibleCues = useVisibleIndexedCues()

  const handleDragEnd = (event: DragEndEvent) => {
    void dropCue(event)
    cueDndActions.endDrag()
  }

  return (
    <DndContext
      onDragStart={({ active }) => cueDndActions.startDrag(String(active.id))}
      onDragEnd={handleDragEnd}
      onDragCancel={cueDndActions.endDrag} // Fix: Clean up on cancelled drag (Escape)
      collisionDetection={pointerWithin}
    >
      <div
        id={GRID_DOM_BODY}
        role="rowgroup"
        className="w-full min-w-max relative"
      >
        {visibleCues.map(({ id }) => (
          <CueDraggable
            key={id}
            cueId={id}
          />
        ))}
      </div>

      <NextHardStartCueOverlay />
      <CueDragOverlay />
    </DndContext>
  )
})
